import { FaLinkedinIn } from "react-icons/fa";
import { useTranslation } from "react-i18next";

// Alumni profile managed from the admin (GET /alumni). Styled to match the
// story cards on the same page.
export default function AlumniCard({ alumni }) {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-[20px] border border-gray-100 shadow-sm overflow-hidden flex flex-col hover:-translate-y-2 hover:shadow-xl hover:border-primary/20 transition-all duration-300">
      {alumni.images && (
        <div className="aspect-[4/3] overflow-hidden bg-gray-50">
          <img src={alumni.images} alt={alumni.name} loading="lazy" className="w-full h-full object-cover object-top" />
        </div>
      )}

      <div className="p-6 flex flex-col gap-5 flex-1">
        {alumni.message && (
          <p className="text-gray-600 text-[15px] leading-[1.8] border-l-2 border-primary/30 pl-4">{alumni.message}</p>
        )}

        <div className="flex items-center justify-between gap-3 mt-auto pt-5 border-t border-gray-100">
          <div className="min-w-0">
            <h3 className="font-bold text-[#0b0f19] text-[14px] leading-none truncate">{alumni.name}</h3>
            {alumni.title && (
              <p className="text-primary font-bold tracking-widest text-[10px] uppercase mt-1.5 truncate">{alumni.title}</p>
            )}
          </div>

          {alumni.link && (
            <a
              href={alumni.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-gray-500 hover:text-[#0A66C2] transition-colors shrink-0"
            >
              <span className="w-6 h-6 bg-[#0A66C2] flex items-center justify-center rounded-sm">
                <FaLinkedinIn size={14} color="white" />
              </span>
              {t("alumniPage.viewProfile")}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
